import { Button, Input, Modal, ModalFooter, Row } from '@amzn/meridian';
import { useJAlertsContext } from 'components/JAlerts/JAlertsContext';
import { isEmpty } from 'es-toolkit/compat';
import { useRenameTrafficProjectMutation } from 'generated/graphql';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

type TPRenameModalProps = {
  onCloseModal: () => void;
  openModal: boolean;
};

export function TPRenameModal({ onCloseModal, openModal }: TPRenameModalProps) {
  const [newProjectNameValue, setNewProjectNameValue] = useState('');
  const [renameTrafficProject] = useRenameTrafficProjectMutation();
  const { trafficProjectId } = useParams<{
    trafficProjectId: string;
  }>();
  const { addAlert } = useJAlertsContext();
  const onRenameTrafficProjectMutation = async () => {
    renameTrafficProject({
      variables: {
        id: trafficProjectId,
        name: newProjectNameValue,
      },
    })
      .then(() => {
        addAlert({
          alertType: 'success',
          message: 'Rename action successful!',
          title: 'Success:',
        });
      })
      .catch(() => {
        addAlert({
          alertType: 'error',
          message: 'There was a Rename error and the action could not be completed',
          title: 'Error:',
        });
      });
    onCloseModal();
  };
  return (
    <Modal closeLabel="Close" onClose={onCloseModal} open={openModal} scrollContainer="modal" title="Rename Traffic Project" width="514px">
      <Input
        data-cy="rename-input"
        id="rename-input"
        label="Project name *"
        onChange={setNewProjectNameValue}
        placeholder="Enter new project name"
        type="text"
        value={newProjectNameValue}
      />
      <ModalFooter>
        <Row alignmentHorizontal="end" width="fit">
          <Button onClick={onCloseModal} size="small" type="secondary">
            Cancel
          </Button>
          <Button
            data-cy="save-button"
            disabled={isEmpty(newProjectNameValue)}
            onClick={onRenameTrafficProjectMutation}
            size="small"
            type="primary"
          >
            Save
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
}
